export default "__VITE_ASSET__BVkhahC$__"